import { render, staticRenderFns } from "./WashProduct.vue?vue&type=template&id=10f1ac17&scoped=true"
import script from "./WashProduct.vue?vue&type=script&lang=js"
export * from "./WashProduct.vue?vue&type=script&lang=js"
import style0 from "./WashProduct.vue?vue&type=style&index=0&id=10f1ac17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f1ac17",
  null
  
)

export default component.exports